<template>
  <div>
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <span>状态
          <el-radio-group v-model="outform.status" @change="handleSearch" style="margin-left: 14px;">
            <el-radio-button label="">全部{{ count.allCount ? `(${count.allCount})` : '' }}</el-radio-button>
            <el-radio-button :label="1">已启用{{ count.enableCount ? `(${count.enableCount})` : '' }}</el-radio-button>
            <el-radio-button :label="2">已禁用{{ count.disableCount ? `(${count.disableCount})` : '' }}</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :toolBar="toolBar"
        :sortInfo.sync="sortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination"
        @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists"
        :highHoverRow="false" :highlightRow="false" />
    </ContentBlock>

    <el-dialog title="查看" :visible.sync="detailDialogVisible" width="45%">
      <div style="padding: 0 20px;">
        <span>所选{{ current.typeText }}：{{ !detailList.length ? `未设置${current.typeText}` : '' }}</span>
        <template v-if="current.type === 1">
          <div v-for="item in detailList" :key="'detail-'+item.id" style="padding: 3px 0;">
            {{ item.fullValue }}
          </div>
        </template>
        <template v-if="current.type === 2">
          <div style="padding: 20px;">{{ (detailList || []).map(item => item.value).join('、') }}</div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="() => detailDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="() => detailDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="`设置【${current.typeText}】`" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
      <el-input placeholder="搜索" v-model.trim="filterText" clearable style="margin-bottom: 10px;"></el-input>
      <div @scroll="handleScroll" style="max-height: 65vh;overflow-y: auto;">
        <el-tree
          v-if="current.type === 1"
          ref="tree"
          :data="baseLists"
          show-checkbox
          node-key="id"
          :default-checked-keys="checkList"
          :props="defaultProps"
          :filter-node-method="filterNode">
        </el-tree>
        <template v-if="current.type === 2">
          <el-checkbox-group v-model="checkList">
            <el-checkbox
            v-for="item in baseLists"
            :label="JSON.stringify(item)"
            :key="item.id"
            style="width: 100%;margin-right: 0;padding: 3px 0;">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="() => dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { queryCount, pageList, itemList, updateStatus, saveItem } from '@/api/subscriptionconfig';
import { getCategoryLists } from '@/api/PlatformSales/Category.js';
import { getBrandLists } from '@/api/PlatformSales/Brand';
import * as dayjs from 'dayjs';
import icRefresh from '@/assets/table/ic_refresh.svg';

const form = {
  status: '',
  name: '',
};

export default {
  name: 'CooperationSubscription',
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  computed: {
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入订阅项名称' style='width:250px;' v-model={this.outform.name}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '订阅项名称',
          minWidth: '100px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '数据类型',
          minWidth: '100px',
          width: '',
          prop: 'dataTypeDesc',
        },
        {
          tooltip: true,
          label: '创建时间',
          minWidth: '100px',
          width: '',
          prop: 'createTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '创建人',
          minWidth: '100px',
          width: '',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '订阅项状态',
          minWidth: '100px',
          width: '',
          prop: 'statusDesc',
        },
      ];

      cols.push({
        label: '操作',
        prop: 'action',
        width: '120px',
        fixed: 'right',
        render: (h, { row }) => {
          let actions = [];
          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleDetail(row); },
            },
          }, '查看'));

          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleSetting(row); },
            },
          }, '设置'));

          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleUpdateStatus(row); },
            },
          }, row.status === 1 ? '禁用' : '启用'));

          return h('div', actions);
        },
      });

      return cols;
    },
  },
  watch: {
    filterText (val) {
      if (this.current.type === 1) {
        this.$refs.tree.filter(val);
      }
      if (this.current.type === 2) {
        setTimeout(() => {
          this.brandPagination.currentPage = 1;
          this.queryBrandList();
        }, 1000);
      }
    },
    dialogVisible (v) {
      if (!v) {
        this.filterText = '';
        this.brandPagination = {
          currentPage: 1,
          pageSize: 50,
        };
        this.isLoading = false;
      }
    },
  },
  data () {
    return {
      count: {
        enableCount: 0,
        disableCount: 0,
        allCount: 0,
      },
      outform: {
        ...form,
      },
      targetLists: [],
      detailList: [],
      detailDialogVisible: false,

      current: {},

      dialogVisible: false,
      filterText: '',
      baseLists: [],
      checkList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      brandPagination: {
        currentPage: 1,
        pageSize: 50,
      },
      isLoading: false,
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleScroll (event) {
      if (this.current.type === 1 || this.isLoading || this.filterText) return;
      const scrollTop = event.target.scrollTop;
      const scrollHeight = event.target.scrollHeight;
      const offsetHeight = event.target.offsetHeight;
      if (scrollTop > (scrollHeight - offsetHeight) - 100) {
        this.brandPagination.currentPage += 1;
        this.queryBrandList();
      }
    },
    async handleSave () {
      let getCheckedNodes = [];
      if (this.current.type === 1) {
        getCheckedNodes = this.$refs.tree.getCheckedNodes();
      }
      if (this.current.type === 2) {
        getCheckedNodes = (this.checkList || []).map(item => JSON.parse(item));
      }
      const itemList = (getCheckedNodes || []).map(item => {
        return {
          key: item.id,
          value: item.name,
        };
      });
      await saveItem({ bizOppSubConfigId: this.current.id, itemList });
      this.$message.success('设置成功');
      this.dialogVisible = false;
      setTimeout(() => {
        this.handleSearch();
      }, 1000);
    },
    dealCurrent () {
      switch (this.current.type) {
      case 1:
        this.current.typeText = '设备分类';
        break;
      case 2:
        this.current.typeText = '品牌';
        break;
      default:
      }
    },
    async handleDetail (row) {
      this.current = row;
      this.dealCurrent();
      this.queryDetail(row.id);
      this.detailDialogVisible = true;
    },
    handleUpdateStatus (row) {
      if (row.status === 1) {
        this.$confirm(`确认禁用【${row.name}】？禁用后此项将不再作为订阅项显示。`, '禁用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'W400',
        }).then(() => {
          updateStatus({ id: row.id, status: 2 }).then(() => {
            this.$message.success('项目已禁用');
            this.handleSearch();
          });
        });
      } else {
        updateStatus({ id: row.id, status: 1 }).then(() => {
          this.$message.success('启用成功');
          this.handleSearch();
        });
      }
    },
    async handleSetting (row) {
      this.checkList = [];
      this.current = row;
      this.dealCurrent();
      if (row.type === 1) {
        const { body } = await getCategoryLists({ parentId: '1747442419689152512', enableFlag: true });
        this.baseLists = body || [];
        await this.queryDetail(row.id);
        this.checkList = (this.detailList || []).map(item => item.key);
      } else {
        this.baseLists = [];
        this.queryBrandList();
        await this.queryDetail(row.id);
        this.checkList = (this.detailList || []).map(item => {
          return JSON.stringify({
            id: item.key,
            name: item.value,
          });
        });
      }
      this.dialogVisible = true;
    },
    async queryBrandList () {
      this.isLoading = true;
      const { body } = await getBrandLists({
        enableFlag: true,
        nameOrShortName: this.filterText,
        pageNum: this.brandPagination.currentPage,
        pageSize: this.brandPagination.pageSize,
      });
      if (this.brandPagination.currentPage === 1) {
        this.baseLists = (body?.list || []).map(item => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      } else {
        this.baseLists = this.baseLists.concat(body?.list || []);
      }
      this.isLoading = false;
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getCount();
      this.getTargetLists();
    },
    handleReset () {
      this.outform = {
        ...form,
      };

      this.pagination.currentPage = 1;

      this.handleSearch();
    },
    async getCount () {
      const { body } = await queryCount({});
      this.count.enableCount = body.enableCount || 0;
      this.count.disableCount = body.disableCount || 0;
      this.count.allCount = this.count.enableCount + this.count.disableCount;
    },
    async queryDetail (id) {
      this.detailList = [];
      const { body } = await itemList({ bizOppSubConfigId: id, findFullValueFlag: true });
      this.detailList = body || [];
    },
    getTargetLists (form = this.outform) {
      const params = {
        ...form,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      pageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = +body?.total || 0;
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}
</style>
